import { createStore, type Store } from "@quotientjs/browser-storage"
import { z } from "zod"

export const SESSION_LAST_ACTIVITY_STORAGE_KEY =
  "quotient-session-last-activity-at"

export type SessionLastActivity = number

/** The timestamp of the last event recorded in the active session. */
export const SessionLastActivityStore: Store<SessionLastActivity, "local"> =
  createStore({
    key: SESSION_LAST_ACTIVITY_STORAGE_KEY,
    validator: z.number().finite().nonnegative(),
    storageType: "local",
  })
